import React from 'react'

const StudentProgress = () => {
  return (
    <div>StudentProgress</div>
  )
}

export default StudentProgress;